export default function() {
  $("[name='SORT_SHOPS']").on('change', function(event) {
    event.preventDefault();

    let $this = $(this);
    let selectedCitySlug = $this.find('option:selected').val();

    window.location.pathname = "/shops/" + selectedCitySlug
  })
}